import { useContext } from 'react';
import Context from './RouterContext';
import matchPath from './matchPath';
export function useHistory() {
  return useContext(Context).history;
}
export function useLocation() {
  return useContext(Context).location;
}
export function useParams() {
  return useContext(Context).match.params;
}
export function useRouteMatch(path) {
  const {
    match: contextMatch
  } = useContext(Context);
  const location = useLocation();
  return path ? matchPath(location.pathname, path) : contextMatch;
}